import React from "react";
import TechNavbar from "../components/TechNavbar";
import Footer from "../components/Footer";
import SubscribeSection from "../components/SubscribeSection";
import FadeInSection from "../components/FadeInSection";
import NewsHeroSection from "../components/News/NewsHeroSection";
import TechInsightsSection from "../components/News/TeachInsightsSection";
import SuccessStoriesSection from "../components/News/SuccessStoriesSection";
import LifeAtCompanySection from "../components/News/LifeAtCompanySection";

const NewsPage = () => {
  return (
    <div className="min-h-screen">
      <TechNavbar />

      {/* HERO SECTION */}
      <FadeInSection>
        <NewsHeroSection />
      </FadeInSection>

      {/* lATEST TECH INSIGHTS */}
      <FadeInSection>
        <TechInsightsSection />
      </FadeInSection>

      {/* SUCCESS STORIES */}
      <FadeInSection>
        <SuccessStoriesSection />
      </FadeInSection>

      {/* LIFE AT COMPANY */}
      <FadeInSection>
        <LifeAtCompanySection />
      </FadeInSection>

      <FadeInSection>
        <SubscribeSection />
      </FadeInSection>

      <Footer />
    </div>
  );
};

export default NewsPage;
